import { useState, useEffect } from "react";
import axios from "axios";
import ColumnContainer from "../shared/columnContainer";

const Team = () => {
  const [posts, setPosts] = useState([]);
  const STATIC_URL = process.env.REACT_APP_STATIC_URL;
  const URL = process.env.REACT_APP_API_URL;

  //const axiosPath = `/posts/columns/team`;
  const axiosPath = URL + `/posts?section=team`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(axiosPath);
        setPosts(res.data);
      } catch (err) {
        console.log("get Posts error", err);
      }
    };
    fetchData();
  }, [axiosPath]);

  const header = posts.filter((post) => post.header_yn === 1)[0];
  const owner = posts.filter((post) => post.more === "OWNER");
  const techs = posts.filter((post) => post.more === "TECH");
  const office = posts.filter((post) => post.more === "OFFICE");

  return (
    <>
      <ColumnContainer id="header" posts={header} />
      <ColumnContainer id="owner" posts={owner} />
      <ColumnContainer id="techs" posts={techs} />
      <ColumnContainer id="office" posts={office} />
    </>
  );
};

export default Team;
